import { render, staticRenderFns } from "./pkgChangeRecord.vue?vue&type=template&id=854b124e&scoped=true&"
import script from "./pkgChangeRecord.vue?vue&type=script&lang=js&"
export * from "./pkgChangeRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854b124e",
  null
  
)

export default component.exports